import { SVGProps, memo } from 'react';
import { PaletteRarity, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

export type LootboxCardBackgroundProps = SVGProps<SVGSVGElement> & {
  rarity: keyof PaletteRarity;
};
export const LootboxCardBackground = memo(
  function LootboxCardBackgroundUnmemoized(props: LootboxCardBackgroundProps) {
    const theme = useTheme();
    const { rarity } = props;

    return (
      <Box sx={{ position: 'absolute', mt: -3.75, ml: 0.5 }}>
        <svg
          width="269"
          height="332.93"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <defs>
            <linearGradient
              y2="1.31739"
              x2="1.25191"
              y1="0.10199"
              x1="0.5"
              id="paint0_linear_5208_154918"
            >
              <stop stopColor={theme.palette.rarity[`${rarity}`]} />
              <stop
                stopColor={theme.palette.rarity[`${rarity}`]}
                offset="0.70313"
              />
            </linearGradient>
            <linearGradient
              y2="1.29902"
              x2="1.21515"
              y1="0.11207"
              x1="0.5061"
              id="paint1_linear_5208_154918"
            >
              <stop stopColor={theme.palette.rarity[`${rarity}`]} />
              <stop
                stopColor={theme.palette.rarity[`${rarity}`]}
                offset="0.70313"
              />
            </linearGradient>
            <linearGradient
              y2="0.49961"
              x2="1.28922"
              y1="0.4996"
              x1="-0.00984"
              id="paint2_linear_5208_154918"
            >
              <stop stopColor={theme.palette.rarity[`${rarity}`]} />
              <stop stopColor={theme.palette.rarity[`${rarity}`]} offset="1" />
            </linearGradient>
            <linearGradient
              y2="0.50405"
              x2="1.39474"
              y1="0.50405"
              x1="-0.07895"
              id="paint3_linear_5208_154918"
            >
              <stop stopColor={theme.palette.rarity[`${rarity}`]} />
              <stop stopColor={theme.palette.rarity[`${rarity}`]} offset="1" />
            </linearGradient>
          </defs>
          <g>
            <title>Layer 1</title>
            <path stroke="null" id="svg_1" opacity="undefined" fill="#000B1A" />
            <path
              stroke="url(#paint0_linear_5208_154918)"
              id="svg_2"
              opacity="undefined"
              strokeWidth="4"
            />
            <path
              stroke="null"
              id="svg_3"
              fill="#000D1F"
              d="m255.4607,2.22101l-224.86108,0c-3.02749,0 -5.93109,1.0742 -8.07236,2.98645l-12.57277,11.22789l240.43736,0l-0.00799,305.54431l-1.18528,1.61811l15.18256,-16.97277c1.61692,-1.80889 2.49845,-4.05547 2.49845,-6.3704l0,-287.83115c0,-5.63465 -5.11224,-10.20244 -11.41889,-10.20244z"
            />
            <path
              stroke="null"
              id="svg_4"
              fill="url(#paint1_linear_5208_154918)"
              d="m264.05399,309.78462l1.79981,1.28622l0,0l-1.79981,-1.28622zm-15.32025,17.14553l-1.92886,-1.12854c-0.67291,0.92035 -9.83754,7.89377 -4.78952,7.30074c5.04802,-0.59304 7.75079,-4.0254 8.51818,-4.88494l-1.79981,-1.28725zm-239.44225,-315.12914l-5.79112,5.7462l-2.29346,3.29405l6.1131,-2.13873l1.97148,-6.90153zm10.71532,-6.5019l-1.62904,-1.45789l0,0l1.62904,1.45789zm229.93103,11.34218l2.30449,0l0,-2.06126l-2.30449,0l0,2.06126zm-0.00807,308.65429l1.92771,1.12854l0.37678,-0.51428l0,-0.61425l-2.30449,0zm-221.7774,-320.95206l226.90028,0l0,-4.12251l-226.90028,0l0,4.12251zm236.11824,8.24503l0,290.76083l4.60898,0l0,-290.76083l-4.60898,0zm-2.01758,295.90882l-15.32025,17.14553l3.60077,2.57451l15.32025,-17.14656l-3.60077,-2.57348zm-253.3039,-290.39826l12.68684,-11.34212l-3.2582,-2.91577l-10.38681,9.31597l0.95817,4.94191zm240.98871,-3.51908l-242.61782,0l0,4.12251l242.61782,0l0,-4.12251zm0.72361,313.47866l1.19603,-1.63458l-3.85656,-2.25708l-1.19603,1.63458l3.85656,2.25708zm1.57281,-2.76311l0.00807,-308.65429l-4.60898,-0.0001l-0.00807,308.65439l4.60898,0zm12.03635,-21.9462c0,1.87162 -0.71094,3.68656 -2.01758,5.14799l3.60077,2.57348c1.95882,-2.19215 3.02579,-4.91507 3.02579,-7.72147l-4.60898,0zm-9.21796,-299.00586c5.09062,0 9.21796,3.69142 9.21796,8.24503l4.60898,0c0,-6.83041 -6.19101,-12.36754 -13.82694,-12.36754l0,4.12251zm-226.90028,-4.12251c-3.66587,0 -7.18183,1.30217 -9.77461,3.62022l3.2582,2.91577c1.7286,-1.54537 4.07249,-2.41347 6.51641,-2.41347l0,-4.12251z"
            />
            <path
              stroke={theme.palette.rarity[`${rarity}`]}
              id="svg_5"
              strokeLinecap="round"
              strokeWidth="6"
              d="m251.55101,15.12574l11,-8.46663"
            />
            <path
              stroke="white"
              id="svg_6"
              strokeWidth="1.5"
              fillOpacity="0.5"
              fill="url(#paint2_linear_5208_154918)"
              d="m28.12437,3.97934l232.55347,0.48545c0.26575,0.00056 0.59953,0.27997 0.19698,0.43398l-11.04026,8.71404c-0.69934,0.5519 -1.61431,0.8582 -2.56425,0.8582l-233.80891,0c-0.25666,0 -0.3879,-0.264 -0.21038,-0.423l8.75178,-7.835c1.59869,-1.43131 3.81094,-2.23849 6.12156,-2.23367z"
            />
            <path
              stroke="white"
              id="svg_7"
              strokeWidth="1.5"
              fillOpacity="0.5"
              fill="url(#paint3_linear_5208_154918)"
              d="m253.3098,16.51586l10.32598,-7.28978c0.19323,-0.13625 0.49381,-0.02504 0.49381,0.18254l0,245.3112c0,0.29229 -0.13121,0.5749 -0.36857,0.79557l-8.34953,7.75634c-0.90533,0.84203 -2.6134,0.32229 -2.6134,-0.79557l0,-245.04762c0,-0.34997 0.18727,-0.68291 0.51171,-0.91268z"
            />
          </g>
        </svg>
      </Box>
    );
  },
);
